export default {
  tags: {
    default: 'Par défaut',
    visible_to: 'Visible par',
    not_visible_to: 'Non visible par',
  },
  labels: {
    inclusive: 'Inclusif',
    exclusive: 'Exclusif',
    public: 'Public',
  },
  buttons: {
    edit: 'Modifier',
    delete: 'Supprimer',
  },
};
